import { InputProps } from '@/components/TicketScanInput/InputProps';
import { Scanner } from '@/components/Scanner';

export const CameraInput = ({ onSubmit, ...props }: InputProps) => <Scanner onScan={onSubmit} {...props} />;
